import api from './api';

export const authApi = {
  register: async (email, password, first_name, last_name) => {
    const body = {
      email,
      password,
      first_name,
      last_name
    }
    try {
      const response = await api.post('/auth/register', body);
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Registration failed',
      };
    }
  },

  login: async (email, password) => {
    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      });
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Login failed',
      };
    }
  },

  verify: async () => {
    try {
      const response = await api.get('/auth/verify');
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Verification failed',
      };
    }
  },

  logout: async () => {
    try {
      const response = await api.post('/auth/logout');
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Logout failed',
      };
    }
  },
}; 